import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';

export async function getHelpContentByPage(page: string) {
  console.log('getHelpContentByPage', page);
  const pageDocRef = doc(db, 'StaticData', 'helpInfo', 'pages', page);
  const pageDocSnap = await getDoc(pageDocRef);

  if (!pageDocSnap.exists()) {
    console.warn(`getHelpContentByPage Help info for page '${page}' not found. This can be expected if the page is enabled for HelpData but not found in the DB.`);
    return null;
  }
  console.log('getHelpContentByPage', pageDocSnap.data())
  return pageDocSnap.data();
}
